module.exports = __webpack_public_path__ + "img/close.f913db3d.svg";